import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@/fontawesome';

interface StepCheckoutProps {
  /** Anzahl der Pakete des Links — bei mehreren läuft die Zahlung in mehreren Stripe-Checkouts nacheinander. */
  totalSteps: number;
}

export default function StepCheckout({ totalSteps }: StepCheckoutProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 space-y-4">
      <FontAwesomeIcon icon={faSpinner} className="w-8 h-8 text-blue-500 animate-spin" />
      <p className="text-gray-700 dark:text-gray-300 font-medium">
        Du wirst zum Checkout weitergeleitet...
      </p>
      {totalSteps > 1 && (
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Zahlung 1 von {totalSteps}
        </p>
      )}
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Bitte warte einen Moment.
      </p>
    </div>
  );
}
